(function(){
  function ready(fn){
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});}
    else{fn();}
  }

  ready(function(){
    document.querySelectorAll('[data-gcq-root]').forEach(function(root){
      if(root.dataset.gcqReady==='v7') return;
      root.dataset.gcqReady='v7';

      var input=root.querySelector('[data-gcq-search]');
      var form=root.querySelector('[data-search-form]');
      var submit=root.querySelector('[data-search-submit]');
      var live=root.querySelector('[data-live-results]');
      var items=Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
      var chapters=Array.prototype.slice.call(root.querySelectorAll('[data-category-block]'));
      var resultCount=root.querySelector('[data-result-count]');
      var resultLabel=root.querySelector('[data-result-label]');
      var empty=root.querySelector('[data-empty]');
      var reset=root.querySelector('[data-reset]');
      var pills=Array.prototype.slice.call(root.querySelectorAll('.gcq-cat-pill'));
      var progress=document.querySelector('.gcq-progress');
      var resultsAnchor=root.querySelector('#faq-results');
      var dynamic=root.querySelector('[data-dynamic-results]');
      var dynamicList=root.querySelector('[data-dynamic-list]');
      var dynamicTitle=root.querySelector('[data-dynamic-title]');
      var dynamicSubtitle=root.querySelector('[data-dynamic-subtitle]');
      var state={query:'',cat:''};

      var synonyms={
        chien:['chien','urine','tache','taches','animal','animaux','pattes'],
        tache:['tache','taches','urine','chien','localise','localisee','jaune'],
        pluie:['pluie','sechage','secher','meteo','humide','humidite','orage','arroser'],
        sechage:['sechage','secher','pluie','humide','meteo','heure','heures'],
        prairie:['prairie','foret','teinte','couleur','vert','lumineux','clair'],
        foret:['foret','prairie','teinte','couleur','vert','fonce','profond','correcteur'],
        enfant:['enfant','enfants','animaux','chien','securite','danger','clp'],
        animal:['animal','animaux','chien','enfants','securite','pattes'],
        pro:['professionnel','professionnels','paysagiste','distributeur','revendeur','collectivite','golf','echantillon'],
        professionnel:['professionnel','professionnels','paysagiste','distributeur','revendeur','collectivite','golf','echantillon'],
        gazon:['gazon','pelouse','jaune','brule','brulee','sec','dormant'],
        haie:['haie','haies','thuyas','thuya','cypres','vegetaux'],
        buis:['buis','pyrale','vegetaux','prairie'],
        dilution:['dilution','diluer','dosage','ratio','pulverisateur','melange'],
        clp:['clp','danger','pictogramme','fds','securite','reach'],
        fds:['fds','securite','clp','danger','composition']
      };

      function normalize(v){
        return (v||'').toString().toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
          .replace(/[’'`]/g,' ')
          .replace(/œ/g,'oe')
          .replace(/m²/g,'m2')
          .replace(/[^a-z0-9]+/g,' ')
          .trim();
      }
      function tokens(v){
        var seen={};
        var base=normalize(v).split(/\s+/).filter(function(t){return t.length>1;}).map(function(t){
          if(t.length>3 && /s$/.test(t)) return t.replace(/s$/,'');
          return t;
        });
        var expanded=[];
        base.forEach(function(t){
          expanded.push(t);
          (synonyms[t]||[]).forEach(function(s){expanded.push(normalize(s));});
        });
        return expanded.filter(function(t){ if(!t || seen[t]) return false; seen[t]=1; return true; });
      }
      function visibleTokens(v){
        var seen={};
        return normalize(v).split(/\s+/).filter(function(t){
          if(t.length<2) return false;
          if(t.length>3 && /s$/.test(t)) t=t.replace(/s$/,'');
          if(seen[t]) return false; seen[t]=1; return true;
        });
      }
      function hay(el){ return normalize(el.getAttribute('data-search')||el.textContent||''); }
      function tokenMatched(h,t){ return h.indexOf(t)!==-1 || (t.length>3 && h.indexOf(t+'s')!==-1); }
      function scoreQuery(el, toks, qnorm){
        if(!toks.length) return {score:1,full:true,phrase:false};
        var h=hay(el);
        var score=0;
        toks.forEach(function(t){ if(tokenMatched(h,t)) score++; });
        var phrase=!!(qnorm && h.indexOf(qnorm)!==-1);
        return {score:score,full:score>=Math.min(toks.length, visibleTokens(state.query).length || toks.length),phrase:phrase};
      }
      function labelForCat(cat){
        var p=root.querySelector('[data-cat-filter="'+cat+'"]');
        if(!p) return 'FAQ';
        return (p.textContent||'').replace(/\d+/g,'').replace(/[⌂✦▣≈↗☁✓●♧◷◆]/g,'').trim();
      }
      function setActive(cat){
        pills.forEach(function(p){
          var isAll=p.hasAttribute('data-filter-all');
          p.classList.toggle('is-active', isAll ? !cat : p.getAttribute('data-cat-filter')===cat);
        });
      }
      function visibleCountInChapter(ch){
        return Array.prototype.slice.call(ch.querySelectorAll('[data-faq-item]')).filter(function(el){return !el.hidden;}).length;
      }
      function closeAllQuestions(){
        root.querySelectorAll('details.gcq-question[open]').forEach(function(d){ d.open=false; });
      }
      function clearMarks(){
        items.forEach(function(el){
          el.classList.remove('is-result','is-hit','is-focus');
          el.style.removeProperty('--gcq-delay');
        });
      }
      function updateUrl(cat){
        if(!history.replaceState) return;
        var url=location.pathname+location.search+(cat?('#cat-'+cat):'');
        history.replaceState(null,'',url);
      }
      function scrollTo(el){
        if(!el) return;
        setTimeout(function(){ el.scrollIntoView({behavior:'smooth',block:'start'}); },40);
      }
      function focusOriginal(card){
        if(!card) return;
        var ch=card.closest('[data-category-block]');
        if(ch){ ch.hidden=false; ch.open=true; }
        card.hidden=false;
        var d=card.querySelector('details.gcq-question');
        if(d) d.open=true;
        card.classList.remove('is-focus');
        void card.offsetWidth;
        card.classList.add('is-focus','is-hit');
        scrollTo(card);
      }
      function getQuestion(card){ return (card.querySelector('.gcq-title')||{}).textContent || ''; }
      function getNumber(card){ return (card.querySelector('.gcq-number')||{}).textContent || ''; }
      function getAnswer(card){ return (card.querySelector('.gcq-answer p')||{}).textContent || ''; }
      function escapeHtml(str){
        return (str||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});
      }
      function highlight(str, rawToks){
        var safe=escapeHtml(str||'');
        var toks=rawToks.filter(function(t){ return t.length>2; }).slice(0,8);
        toks.forEach(function(t){
          var re=new RegExp('('+t.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','ig');
          safe=safe.replace(re,'<mark>$1</mark>');
        });
        return safe;
      }
      function renderDynamic(matches, query, cat){
        if(!dynamic || !dynamicList) return;
        dynamicList.innerHTML='';
        var filtering=!!(query || cat);
        if(!filtering){ dynamic.hidden=true; return; }
        var rawToks=visibleTokens(query);
        dynamic.hidden=false;
        if(dynamicTitle){
          dynamicTitle.textContent=query ? ('Questions liées à « '+query+' »') : ('Questions du chapitre '+labelForCat(cat));
        }
        if(dynamicSubtitle){
          dynamicSubtitle.textContent=matches.length ? (matches.length+' question'+(matches.length>1?'s':'')+' affichée'+(matches.length>1?'s':'')+' ci-dessous. Cliquez sur une carte pour zoomer sur la réponse dans la FAQ.') : 'Aucun résultat. Essayez un autre mot-clé ou envoyez une photo sur WhatsApp.';
        }
        matches.slice(0,60).forEach(function(card,idx){
          var btn=document.createElement('button');
          btn.type='button';
          btn.className='gcq-result-card';
          btn.style.setProperty('--gcq-delay',Math.min(idx,18)*28+'ms');
          var q=getQuestion(card);
          var a=getAnswer(card);
          var num=getNumber(card);
          var chapter=labelForCat(card.getAttribute('data-category')||'');
          btn.innerHTML='<span class="gcq-result-num">'+escapeHtml(num)+'</span><span class="gcq-result-body"><small>'+escapeHtml(chapter)+'</small><strong>'+highlight(q,rawToks)+'</strong><em>'+highlight(a,rawToks)+'</em></span><span class="gcq-result-arrow">↘</span>';
          btn.addEventListener('click',function(){ focusOriginal(card); });
          dynamicList.appendChild(btn);
        });
        if(matches.length>60){
          var more=document.createElement('div');
          more.className='gcq-result-more';
          more.textContent=(matches.length-60)+' autres questions restent filtrées dans les chapitres ouverts ci-dessous.';
          dynamicList.appendChild(more);
        }
      }
      function updateLive(toks, query, matched){
        if(!live) return;
        live.innerHTML='';
        if(!query || !toks.length){ live.hidden=true; return; }
        var slice=matched.slice(0,5);
        if(!slice.length){ live.hidden=true; return; }
        var title=document.createElement('div');
        title.className='gcq-live-title';
        title.textContent=slice.length+' résultat'+(slice.length>1?'s':'')+' rapide'+(matched.length>slice.length?' sur '+matched.length:'');
        live.appendChild(title);
        slice.forEach(function(card){
          var a=document.createElement('button');
          a.type='button';
          a.className='gcq-live-result';
          a.innerHTML='<strong>'+escapeHtml(getNumber(card))+'</strong><span>'+escapeHtml(getQuestion(card))+'</span><small>'+escapeHtml(labelForCat(card.getAttribute('data-category')||''))+'</small>';
          a.addEventListener('click',function(){ renderAndScroll(query,'',true); focusOriginal(card); });
          live.appendChild(a);
        });
        live.hidden=false;
      }
      function computeMatches(query, cat){
        state.query=query||'';
        state.cat=cat||'';
        var toks=tokens(state.query);
        var qnorm=normalize(state.query);
        var rawCount=visibleTokens(state.query).length;
        var scored=items.map(function(el){
          var okC=!state.cat || el.getAttribute('data-category')===state.cat;
          var sq=scoreQuery(el,toks,qnorm);
          var relevance=sq.phrase ? 999 : sq.score;
          return {el:el,okC:okC,score:sq.score,phrase:sq.phrase,relevance:relevance};
        });
        var threshold=rawCount>1 ? Math.min(rawCount,2) : 1;
        var matched=scored.filter(function(x){
          if(!x.okC) return false;
          if(!toks.length) return true;
          return x.phrase || x.score>=threshold;
        }).sort(function(a,b){
          if(b.relevance!==a.relevance) return b.relevance-a.relevance;
          return parseInt(getNumber(a.el),10)-parseInt(getNumber(b.el),10);
        }).map(function(x){return x.el;});
        return {matched:matched,toks:toks};
      }
      function apply(query,cat,opts){
        opts=opts||{};
        var data=computeMatches(query,cat);
        var matched=data.matched;
        var filtering=!!(state.query || state.cat);
        var matchSet=new Set(matched);
        var delay=0;

        root.classList.toggle('gcq-has-filter', filtering);
        clearMarks();
        if(!opts.keepOpen) closeAllQuestions();

        items.forEach(function(el){
          var show=filtering ? matchSet.has(el) : true;
          el.hidden=!show;
          if(show && filtering){
            el.classList.add('is-result');
            el.style.setProperty('--gcq-delay',Math.min(delay,18)*28+'ms');
            delay++;
            var d=el.querySelector('details.gcq-question');
            if(d && matched.length<=18) d.open=true;
          }
        });

        chapters.forEach(function(ch){
          var visible=visibleCountInChapter(ch);
          ch.hidden=!visible;
          ch.open=filtering ? visible>0 : false;
          var badge=ch.querySelector('[data-visible-count]');
          if(badge) badge.textContent=visible;
        });

        if(resultCount) resultCount.textContent=matched.length;
        if(resultLabel){
          if(state.query && state.cat){ resultLabel.textContent='questions visibles pour « '+state.query+' » dans '+labelForCat(state.cat); }
          else if(state.query){ resultLabel.textContent='questions visibles pour « '+state.query+' »'; }
          else if(state.cat){ resultLabel.textContent='questions visibles du chapitre '+labelForCat(state.cat); }
          else { resultLabel.textContent='questions disponibles'; }
        }
        if(empty) empty.classList.toggle('is-visible', filtering && matched.length===0);
        setActive(state.cat);
        renderDynamic(matched,state.query,state.cat);
        updateLive(data.toks,state.query,matched);

        if(opts.focusFirst && matched[0]) focusOriginal(matched[0]);
        if(opts.scroll){ scrollTo(dynamic && !dynamic.hidden ? dynamic : resultsAnchor); }
        return {shown:matched.length,matched:matched,first:matched[0]};
      }
      function renderAndScroll(query, cat, focusFirst){
        var res=apply(query,cat,{scroll:true,focusFirst:!!focusFirst});
        return res;
      }
      function goCat(cat){
        if(input) input.value='';
        renderAndScroll('',cat,false);
        updateUrl(cat);
      }
      function submitSearch(){
        var value=input ? input.value : '';
        renderAndScroll(value,'',false);
      }

      if(input){
        var t;
        input.addEventListener('input',function(){
          clearTimeout(t);
          t=setTimeout(function(){ apply(input.value,'',{scroll:visibleTokens(input.value).length>0}); },80);
        });
        input.addEventListener('keydown',function(e){
          if(e.key==='Enter'){ e.preventDefault(); submitSearch(); }
          if(e.key==='Escape'){ input.value=''; apply('','',{scroll:false}); }
        });
      }
      if(form){ form.addEventListener('submit',function(e){e.preventDefault(); submitSearch();}); }
      if(submit){ submit.addEventListener('click',function(e){e.preventDefault(); submitSearch();}); }
      root.querySelectorAll('[data-quick-search]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var q=btn.getAttribute('data-quick-search')||'';
          if(input){input.value=q;}
          renderAndScroll(q,'',false);
        });
      });
      root.querySelectorAll('[data-cat-filter]').forEach(function(el){
        el.addEventListener('click',function(ev){ ev.preventDefault(); ev.stopPropagation(); goCat(el.getAttribute('data-cat-filter')||''); });
      });
      root.querySelectorAll('[data-filter-all]').forEach(function(el){
        el.addEventListener('click',function(ev){
          ev.preventDefault(); if(input) input.value=''; apply('','',{scroll:true}); updateUrl('');
        });
      });
      if(reset){
        reset.addEventListener('click',function(){ if(input) input.value=''; apply('','',{scroll:true}); updateUrl(''); });
      }
      root.querySelectorAll('.gcq-question').forEach(function(d){
        d.addEventListener('toggle',function(){
          if(d.open){
            var card=d.closest('[id]');
            if(card && history.replaceState) history.replaceState(null,'','#'+card.id);
          }
        });
      });
      function openHash(){
        var id=location.hash.slice(1);
        if(!id) return;
        var el=document.getElementById(id);
        if(!el) return;
        if(id.indexOf('cat-')===0 && el.matches('[data-category-block]')){ goCat(el.getAttribute('data-category-block')); return; }
        var ch=el.closest('[data-category-block]');
        if(ch){ if(input) input.value=''; apply('',ch.getAttribute('data-category-block'),{scroll:false}); }
        focusOriginal(el);
      }
      window.addEventListener('hashchange',openHash);
      openHash();

      if('IntersectionObserver' in window){
        var obs=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting && !state.cat && !visibleTokens(state.query).length){setActive(entry.target.getAttribute('data-category-block'));}
          });
        },{rootMargin:'-25% 0px -65% 0px',threshold:0});
        chapters.forEach(function(s){obs.observe(s);});
      }
      function onScroll(){
        if(!progress) return;
        var h=document.documentElement;
        var max=h.scrollHeight-h.clientHeight;
        progress.style.width=(max?window.scrollY/max*100:0)+'%';
      }
      window.addEventListener('scroll',onScroll,{passive:true});
      onScroll();
      apply('','',{scroll:false});
    });
  });
})();
